import { createFileRoute } from "@tanstack/react-router";

import type { RouterContextType } from "@/api/permissions/permissions.api";
import { MODULE_KEYS_MAP } from "@/api/permissions/permissions.types";
import { ProcurementCalendarPage } from "@/components/features/Procurement/calendar/ProcurementCalendarPage";
import { useBreadcrumb } from "@/hooks/useBreadcrumb";
import { authGuardWithPermissions } from "@/utils/authGuard";
import { getRouteIcon } from "@/utils/getRouteIconComponent";

export const Route = createFileRoute("/_authenticated/procurement/calendar")({
  component: ProcurementCalendarRoute,
  beforeLoad: async (args) => {
    await authGuardWithPermissions({
      context: args.context as RouterContextType,
      location: args.location as { pathname: string },
    });
  },
});

function ProcurementCalendarRoute() {
  useBreadcrumb([
    {
      title: "Procurement",
      href: "/procurement",
      icon: getRouteIcon(MODULE_KEYS_MAP.procurement),
    },
    { title: "Calendar", href: "/procurement/calendar" },
  ]);

  return <ProcurementCalendarPage />;
}
